<template>
	<div class="flexCol alit">
		<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E5%A4%A7%E7%94%B0/1.png"
			alt="" />
		<div class="title" style="margin-top: 40px;margin-bottom: 15px;">温室大棚的现存问题及发展契机</div>
		<img style="width: 80%;"
			src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E5%A4%A7%E7%94%B0/e4861f63-6d11-4b63-a73b-bb6f7eadefbb.png"
			alt="" />
		<div class="title" style="margin-top: 40px;margin-bottom: 15px;">智慧大田解决方案</div>
		<div class="title-desc">智能监测·智能灌溉</div>
		<div class="desc" style="margin-top: 20px;">
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;广积粮智慧农业服务系统，通过 “感、知、控、溯”
			一体化，实现对农业生产全链条的数字化、智能化和精细化管理。其核心功能可概括为以下四个方面：<br />
			<h4 style="margin: 5px 0;">全域感知与精准监测功能：</h4>
			 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;通过物联网设备，实时采集田间环境数据（气象、土壤温湿度、光照等）和作物本体数据（长势、病虫害视觉信息）。价值：将农田状况“透明化”，为精准决策提供数据基础。<br />
			<h4 style="margin: 5px 0;">智能决策与精准作业功能：</h4>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;基于AI算法与大数据模型，提供智能决策建议，如水肥一体化方案、病虫害预警与用药指导、产量预测等，并可通过控制中心远程执行灌溉、施肥等操作。价值：变“经验驱动”为“数据驱动”，实现降本增效、提质增产。<br />
			<h4 style="margin: 5px 0;">数字管理与全程可溯功能：</h4>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;对农事活动（耕种管收）、投入品使用（农药、肥料）进行数字化记录与管理，并生成唯一的产品溯源二维码。价值：实现生产过程的规范化管理与透明化追溯，为农产品品质与安全背书。<br />
			<h4 style="margin: 5px 0;">资源协同与产销对接功能：</h4>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;整合农机调度、劳动力管理、供应链信息，并可与下游电商平台数据打通，根据市场需求指导生产计划。价值：优化资源配置，初步实现“以销定产”，提升产业整体效益。<br /><br />
			广积粮智慧农业服务系统是农田的“智慧大脑”，旨在让农业生产更智能、更高效、更可持续。
		</div>
		<!-- <div class="title" style="margin-top: 40px;margin-bottom: 15px;">方案5大优势</div> -->
		<img style="width: 70%;"
			src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E5%A4%A7%E7%94%B0/%E4%BC%98%E5%8A%BF.png"
			alt="" />
		<video style="width: 70%;"
			src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E5%A4%A7%E7%94%B0/%E5%8D%83%E5%B9%BF%E9%81%A5%E6%84%9F%2BAI.mp4"
			controls></video>
		<!-- <img style="width: 80%;margin: 10px 0;"
			src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/%E7%81%AB%E9%94%85%E4%BA%A7%E4%B8%9A/%E5%B9%B3%E5%8F%B0%E6%9C%8D%E5%8A%A1.png"
			alt="" /> -->
	</div>
</template>

<script>
</script>

<style scoped>
	.sj-cont {
		width: 24%;
		background-color: rgb(12 84 166);
		color: #fff;
		height: 50px;
		text-align: center;
		line-height: 50px;
		font-size: 24px;
		margin-top: 10px;
	}

	.desc {
		width: 80%;
		font-size: 24px;
	}

	img {
		width: 100%;
	}

	.title {
		text-align: center;
		font-weight: 900;
		font-size: 34px;
		margin: 20px 0;
		color: rgb(86 146 48);
	}

	.title-desc {
		text-align: center;
		font-size: 17px;
		color: rgb(151 151 151);
		margin-bottom: 20px;
	}
</style>